import site from './site';

export default {
    ...site,
};
